import React from "react";

import Tag from "antd/es/tag";
import { defineMessages } from "react-intl";

import { EntityType, Route } from "@mapmycustomers/shared/types/entity";
import { Avatar } from "@mapmycustomers/ui";

import RouteName from "@app/component/route/RouteName";
import UserPreviewCard from "@app/component/UserPreviewCard";
import { formatRawDate } from "@app/util/formatters";

import styles from "../EntityListModal.module.scss";

import { ColumnsFactory } from "./ColumnsFactory";

export const messages = defineMessages({
  companyItems: {
    id: "reports.overview.routeList.column.route.companyItems",
    defaultMessage: "{items} {items, plural, one {Company} other {Companies}}",
    description:
      "Number of company items in Route column in Routes table on Routes Modal on Overview page",
  },
  createdAt: {
    id: "reports.overview.routeList.column.createdAt",
    defaultMessage: "Created at",
    description: "Title of a Created at column in Routes table on Routes Modal on Overview page",
  },
  owner: {
    id: "reports.overview.routeList.column.owner",
    defaultMessage: "Owner",
    description: "Title of a Owner column in Routes table on Routes Modal on Overview page",
  },
  peopleItems: {
    id: "reports.overview.routeList.column.route.peopleItems",
    defaultMessage: "{items} {items, plural, one {Person} other {People}}",
    description:
      "Number of person items in Route column in Routes table on Routes Modal on Overview page",
  },
  route: {
    id: "reports.overview.routeList.column.route",
    defaultMessage: "Route",
    description: "Title of a Route column in Routes table on Routes Modal on Overview page",
  },
  startingLocation: {
    id: "reports.overview.routeList.column.startingLocation",
    defaultMessage: "Starting Location",
    description:
      "Title of a Starting Location column in Routes table on Routes Modal on Overview page",
  },
});

export const createRouteListColumns: ColumnsFactory<Route> = (intl) => [
  {
    dataIndex: "name",
    key: "name",
    render: (ignore: any, route) => {
      const items =
        route.items > 0 &&
        intl.formatMessage(
          route.itemType === EntityType.COMPANY_ROUTE
            ? messages.companyItems
            : messages.peopleItems,
          {
            items: route.items,
          }
        );
      return <RouteName items={items} route={route} />;
    },
    title: intl.formatMessage(messages.route),
  },
  {
    className: styles.secondaryCol,
    dataIndex: "routeDetail",
    key: "startAddress",
    render: ({ startAddress }: Route["routeDetail"]) => startAddress,
    title: intl.formatMessage(messages.startingLocation),
  },
  {
    dataIndex: "routeDetail",
    key: "createdAt",
    render: ({ createdAt }: Route["routeDetail"]) => <Tag>{formatRawDate(createdAt, "PPPpp")}</Tag>,
    title: intl.formatMessage(messages.createdAt),
  },
  {
    dataIndex: "user",
    key: "user",
    render: (user: Route["user"]) => (
      <UserPreviewCard userId={user.id}>
        <Avatar actionOnHover user={user} />
      </UserPreviewCard>
    ),
    title: intl.formatMessage(messages.owner),
    width: "15%",
  },
];
